// constants/prescriptionConstants.js

export const SPHERE_INCREMENT = 0.25;
export const SPHERE_MIN = -20.00;
export const SPHERE_MAX = 20.00;

export const CYLINDER_INCREMENT = 0.25;
export const CYLINDER_MIN = -6.00; // Or wider range like -10.00
export const CYLINDER_MAX = 6.00; // Or wider range like +6.00

export const AXIS_MIN = 1;
export const AXIS_MAX = 180;
export const AXIS_INCREMENT = 1;

export const ADD_INCREMENT = 0.25;
export const ADD_MIN = 0.75;
export const ADD_MAX = 3.50; // Typically +0.75 to +3.50 or +4.00

export const PRISM_BASE_OPTIONS = [
  { value: 'BU', label: 'Base Up' },
  { value: 'BD', label: 'Base Down' },
  { value: 'BI', label: 'Base In' },
  { value: 'BO', label: 'Base Out' },
];

// For PD, Seg Ht, etc., define similar min/max/increment constants
export const PD_INCREMENT = 0.5; // or 1.0 depending on precision needed
export const PD_MIN = 40.0;
export const PD_MAX = 80.0;

// ... and so on for other fields
export const SEGMENT_HEIGHT_INCREMENT = 0.5; // or 1.0 depending on precision needed
export const SEGMENT_HEIGHT_MIN = 10.0; // Minimum segment height in mm
export const SEGMENT_HEIGHT_MAX = 40.0; // Maximum segment height in mm

